import { render, staticRenderFns } from "./TrendPage.vue?vue&type=template&id=08581118"
import script from "./TrendPage.vue?vue&type=script&lang=js"
export * from "./TrendPage.vue?vue&type=script&lang=js"
import style0 from "./TrendPage.vue?vue&type=style&index=0&id=08581118&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports